import { importLibrary, setOptions } from '@googlemaps/js-api-loader'

let areGoogleMapsOptionsSet = false

const setGoogleMapsOptions = () => {
  if (areGoogleMapsOptionsSet) return

  setOptions({
    key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string,
    v: 'weekly',
  })

  areGoogleMapsOptionsSet = true
}

export const importGoogleMapsLibrary = async (): Promise<google.maps.MapsLibrary> => {
  setGoogleMapsOptions()

  return await importLibrary('maps')
}
